import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store/index';
import { hasHighTierAccess } from '../../../../helper/subscriptionHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const AuditEventsHome = () => import('./Index.vue');

const routerGuard = async (to, from, next) => {
  // On a hard refresh/direct link, the store is empty and stripe/getPlanName reads null
  // before App.vue's own subscription fetch resolves, which bounced every reload to
  // general_settings_index regardless of actual plan. fetchSubscription is idempotent
  // (it no-ops once this account's plan is already cached), so this is safe to call from
  // in-app navigation too.
  await store.dispatch('stripe/fetchSubscription', { id: to.params.accountId });
  if (!hasHighTierAccess(store)) {
    return next({ name: 'general_settings_index' });
  }
  next();
};

export default {
  routes: [
    // The audit-trail page this replaced was linked from bookmarks and support tickets.
    // Redirect rather than 404 them.
    {
      path: frontendURL('accounts/:accountId/settings/audit-trail'),
      redirect: to =>
        frontendURL(
          `accounts/${to.params.accountId}/settings/audit-events/list`
        ),
    },
    {
      path: frontendURL('accounts/:accountId/settings/audit-trail/list'),
      redirect: to =>
        frontendURL(
          `accounts/${to.params.accountId}/settings/audit-events/list`
        ),
    },
    {
      path: frontendURL('accounts/:accountId/settings/audit-events'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'audit_events_list',
          meta: {
            permissions: ['administrator'],
          },
          component: AuditEventsHome,
          beforeEnter: routerGuard,
        },
      ],
    },
  ],
};
